import React from 'react'

const Dash = ({location}) => {
  return (
    <div>
      <p>Jarvis</p>
    </div>
  )
}
export default Dash